import { loc } from '@/__core__/localization/localization'
import { SportsModeServiceRepository } from '@/__core__/repository/sports-mode-service.repository'
import { defineStore } from 'pinia'

/** @typedef {{ sportType: string, eventId: string, languageIdentifier: string, region: string }} Payload */
export const useFootballTeamProfileStore = defineStore('teamProfile', {
  state: () => ({
    teamProfile: {},
    generalInfo: {
      nextMatchHeader: null,
      jerseyData: null,
      stadiumData: null,
      previousMeetings: null
    }
  }),

  getters: {
    getTeamProfileData: state => state.teamProfile
  },

  actions: {
    /** @param {Payload} payload */
    async fetchTeamProfileWidgetData(payload) {
      try {
        const responseTeamProfile = await SportsModeServiceRepository.FootballTeamProfile.get(payload)

        if (!responseTeamProfile) {
          throw new Error('Team profile data not found')
        }

        this.teamProfile = responseTeamProfile.data
        
        const nextMatch = responseTeamProfile.data?.upcomingMatches?.[0] || {}
        const { teams, round, competition, isGameLive, matchStatus, startTime, periodScores = [], status, previousMeetings } = nextMatch
        let home = teams.find(team => team.qualifier === 'home')
        let away = teams.find(team => team.qualifier === 'away')
        let penaltiesScore = periodScores.find(period => period.type === 'penalties')
        const startDate = new Date(startTime) // Convert to Date object
        const currentDate = new Date() // Get the current date and time
        let competitionLabel = competition.name
      
        if (round.number) {
          competitionLabel += `, ${loc('sm_round_rs', payload.langId)} ${round.number}`
        } else if (round.name) {
          const labelKey = `sm_${round.name}`
          competitionLabel += `, ${loc(labelKey, payload.langId)}`
        } else {
          // do nothing
        }
      
        const nextMatchHeader = {
          matchStatus,
          home,
          away,
          startTime,
          isGameLive,
          competitionLabel,
          status,
          upcoming: startDate > currentDate,
          penaltiesScore: penaltiesScore && `${penaltiesScore.home}:${penaltiesScore.away}`
        }

        const team = responseTeamProfile.data?.team || {}
        const stadiumData = team.venue || {}
        const jerseys = team.jerseys || []
        
        const { homeJersey, awayJersey } = jerseys.reduce((acc, jersey) => {
          if (jersey.type === 'home' && !acc.homeJersey) {
            acc.homeJersey = jersey
          }
          if (jersey.type === 'away' && !acc.awayJersey) {
            acc.awayJersey = jersey
          }
          // fallback: if either is still null, use any available jersey
          if (!acc.homeJersey) acc.homeJersey = jersey
          if (!acc.awayJersey) acc.awayJersey = null
          return acc
        }, { homeJersey: null, awayJersey: null })

        this.generalInfo = {
          nextMatchHeader,
          stadiumData,
          jerseyData: {
            home: homeJersey,
            away: awayJersey
          }, 
          previousMeetings
        }
      } catch (error) {
        throw new Error(`[TeamProfileWidget.store, fetchTeamProfileWidgetData]: ${error.message}`)
      }
    }
  }
})
